import React from 'react'
import { components } from 'react-select'

import './activator.scss'

const Activator = (props) => {
  const { className, classNamePrefix, size, disabled, onClick, labelText, style } = props

  const onActivatorClick = (e) => {
    if (!disabled) {
      onClick(e)
    }
  }

  const getSizeClass = () => {
    switch (size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  // const limit = 20
  // let label = labelText
  // if (label.length > limit) {
  //   // Cut label to 'limit' size
  //   label = label.split(' ').reduce((lbl, l) => {
  //     const lblLength = lbl.length
  //     const isFirst = lblLength === 0
  //     if (!isFirst && lblLength > limit) return lbl

  //     if (!isFirst && (l.length + lblLength) > (limit + 3)) {
  //       return lbl
  //     }

  //     return `${lbl} ${l}`
  //   }, '')

  //   if (label.endsWith(',')) {
  //     label += ' ...'
  //   } else if (label.trim() !== labelText) {
  //     label += '...'
  //   }
  // }

  const prefixify = (innerClass) => {
    if (!classNamePrefix) return innerClass
    return `${classNamePrefix}__${innerClass}`
  }

  let classes = className + getSizeClass()
  if (disabled) {
    classes += ` ${prefixify('activator--is-disabled')}`
  }

  return (
    <div className={prefixify('activator ') + classes} style={style} onClick={onActivatorClick}>
      <div className={prefixify('activator-label')}>{labelText}</div>
      <div className={prefixify('activator-indicators')}>
        <div className={prefixify('activator-indicator')}>
          <components.DownChevron />
        </div>
      </div>
    </div>
  )
}

export default Activator



// WEBPACK FOOTER //
// ./src/app/shared/elements/dropDown/Activator/index.js